import { ChartType } from 'business/data-analysis/pages/graph/components/chart/types';
import {
  GraphPageState,
  GraphState,
} from 'business/data-analysis/pages/graph/hooks/graph-context/types';
import { GraphSetTypeEnum_Enum } from 'generated/graphql';

export const resetGraphChartType = (
  graphSet: GraphPageState,
  graph: GraphState,
): GraphState => {
  if (graph.parameters.size !== 0) {
    return graph;
  }
  return {
    ...graph,
    chartType:
      graphSet.structure.type === GraphSetTypeEnum_Enum.Period
        ? ChartType.LINE
        : ChartType.BAR,
  };
};
